import { useTranslation } from 'react-i18next';
import { BuyerTypes } from '../../../../enums';
import { BuyerTypeFilter } from '../../../../models/Filters';
import { resources } from '../../../../resources/resources';
import { CheckboxFilter } from '../Common/CheckboxFilter';
import { mapToBuyerTypeFilterItems } from '../helpers';

interface BuyerTypeFilterProps {
  buyerTypeList: BuyerTypeFilter[];
  prevSelectedBuyerTypes: BuyerTypes[];
  handleBuyerTypeFilterChanged: (buyerTypes: number[]) => void;
}

export default function BuyerTypeFilterComponent(
  props: Readonly<BuyerTypeFilterProps>,
) {
  const { t: translate } = useTranslation();
  const {
    buyerTypeList,
    prevSelectedBuyerTypes,
    handleBuyerTypeFilterChanged,
  } = props;

  return (
    <CheckboxFilter
      title={translate(resources.filters.buyerType.title)}
      filterItems={mapToBuyerTypeFilterItems(
        buyerTypeList,
        prevSelectedBuyerTypes,
      )}
      handleOnClick={handleBuyerTypeFilterChanged}
    />
  );
}
